import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {hostInfoActions} from "./HostInfoSlice";
import {hostInfoApi} from "../../api";

function* fetchDemoList(action)
{
	try
	{
		const response = yield call(hostInfoApi.gets, action.payload);
		yield put(hostInfoActions.fetchDataSuccess(response))
	}
	catch (error)
	{
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(hostInfoActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action)
{
	yield put(hostInfoActions.setFilter(action.payload));
}

export default function* hostInfoSaga()
{
	yield takeLatest(hostInfoActions.fetchData.type, fetchDemoList);
	yield debounce(500, hostInfoActions.setFilterWithDebounce.type, handleSearchDebounce)
}